var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.5H17.9677C18.7962 1.5 19.4677 2.17158 19.4677 3V17.9677C19.4677 18.7962 18.7962 19.4677 17.9677 19.4677H3C2.17157 19.4677 1.5 18.7962 1.5 17.9677V3C1.5 2.17157 2.17158 1.5 3 1.5ZM0 3C0 1.34315 1.34315 0 3 0H17.9677C19.6246 0 20.9677 1.34315 20.9677 3V17.9677C20.9677 19.6246 19.6246 20.9677 17.9677 20.9677H3C1.34315 20.9677 0 19.6246 0 17.9677V3ZM13.3972 5.40313C13.7089 5.13037 13.7405 4.65654 13.4677 4.34482C13.1949 4.03309 12.7211 4.0015 12.4094 4.27426L5.95778 9.91942C5.79502 10.0618 5.70166 10.2676 5.70166 10.4839C5.70166 10.7001 5.79502 10.9059 5.95778 11.0483L12.4094 16.6934C12.7211 16.9662 13.1949 16.9346 13.4677 16.6229C13.7405 16.3112 13.7089 15.8373 13.3972 15.5646L7.5906 10.4839L13.3972 5.40313Z",
    fill: "#D0D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageArrowLeft);
export default __webpack_public_path__ + "static/media/PageArrowLeft.6117f96e9ce639933882bb83d5c070b2.svg";
export { ForwardRef as ReactComponent };